import http from '../_http'

const result = {
  //default
  summaryResult: (m) => { return http.get(`manager/wmds/result`, m); },
  listResult: (m) => { return http.post(`manager/wmds/result/list`, m); },
  detailResult: (m) => { return http.get(`manager/wmds/result/${m.id}`); },
}

export default result

export { result }